/**
 * Showcase Theme - Scroll Animations
 */

document.addEventListener('DOMContentLoaded', function() {
  initScrollAnimations();
  initParallax();
  initCounters();
});

/**
 * Intersection Observer for scroll animations
 */
function initScrollAnimations() {
  const animatedElements = document.querySelectorAll('[data-animate]');
  
  if (!animatedElements.length) return;
  
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        
        // Optionally unobserve after animation
        if (!entry.target.dataset.animateRepeat) {
          observer.unobserve(entry.target);
        }
      } else if (entry.target.dataset.animateRepeat) {
        entry.target.classList.remove('is-visible');
      }
    });
  }, {
    threshold: 0.1,
    rootMargin: '0px 0px -10% 0px'
  });
  
  animatedElements.forEach(el => observer.observe(el));
}

/**
 * Parallax scrolling effect
 */
function initParallax() {
  const parallaxElements = document.querySelectorAll('[data-parallax]');
  
  if (!parallaxElements.length) return;
  
  function updateParallax() {
    const scrollTop = window.pageYOffset;
    
    parallaxElements.forEach(el => {
      const speed = parseFloat(el.dataset.parallax) || 0.5;
      const rect = el.getBoundingClientRect();
      const elementTop = rect.top + scrollTop;
      const visible = scrollTop + window.innerHeight > elementTop && scrollTop < elementTop + rect.height;
      
      if (visible) {
        const yPos = (scrollTop - elementTop) * speed;
        el.style.transform = `translate3d(0, ${yPos}px, 0)`;
      }
    });
  }
  
  window.addEventListener('scroll', updateParallax, { passive: true });
  updateParallax();
}

/**
 * Animated number counters
 */
function initCounters() {
  const counters = document.querySelectorAll('[data-counter]');
  
  if (!counters.length) return;
  
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        animateCounter(entry.target);
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.5 });
  
  counters.forEach(counter => observer.observe(counter));
}

function animateCounter(element) {
  const target = parseInt(element.dataset.counter);
  const duration = parseInt(element.dataset.counterDuration) || 2000;
  const suffix = element.dataset.counterSuffix || '';
  const prefix = element.dataset.counterPrefix || '';
  
  let start = 0;
  const startTime = performance.now();
  
  function update(currentTime) {
    const elapsed = currentTime - startTime;
    const progress = Math.min(elapsed / duration, 1);
    
    // Easing function (ease-out)
    const easeOut = 1 - Math.pow(1 - progress, 3);
    
    const current = Math.floor(easeOut * target);
    element.textContent = prefix + current.toLocaleString() + suffix;
    
    if (progress < 1) {
      requestAnimationFrame(update);
    } else {
      element.textContent = prefix + target.toLocaleString() + suffix;
    }
  }
  
  requestAnimationFrame(update);
}

/**
 * Text reveal animation
 */
function initTextReveal() {
  const revealElements = document.querySelectorAll('[data-text-reveal]');
  
  revealElements.forEach(el => {
    const text = el.textContent;
    el.innerHTML = '';
    
    text.split('').forEach((char, i) => {
      const span = document.createElement('span');
      span.textContent = char === ' ' ? '\u00A0' : char;
      span.style.animationDelay = `${i * 0.03}s`;
      span.className = 'text-reveal-char';
      el.appendChild(span);
    });
  });
}

/**
 * Stagger animation for lists
 */
function initStaggerAnimation() {
  const staggerContainers = document.querySelectorAll('[data-stagger]');
  
  staggerContainers.forEach(container => {
    const children = container.children;
    const delay = parseFloat(container.dataset.stagger) || 0.1;
    
    Array.from(children).forEach((child, i) => {
      child.style.transitionDelay = `${i * delay}s`;
    });
  });
}
